import { useState } from "react";
import axios from "axios";
import { CheckCircle2, AlertCircle, Loader2 } from "lucide-react";
import { API } from "@/lib/shared";

const ContactForm = () => {
  const [form, setForm] = useState({
    nombre: "",
    empresa: "",
    correo: "",
    telefono: "",
    mensaje: "",
  });
  const [status, setStatus] = useState("idle");
  const [errorMsg, setErrorMsg] = useState("");

  const handleChange = (field) => (e) =>
    setForm((f) => ({ ...f, [field]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("loading");
    setErrorMsg("");
    try {
      const { data } = await axios.post(`${API}/contact`, form);
      if (data && data.success) {
        setStatus("success");
        setForm({
          nombre: "",
          empresa: "",
          correo: "",
          telefono: "",
          mensaje: "",
        });
      } else {
        setStatus("error");
        setErrorMsg(
          (data && data.error) || "Algo salió mal. Intenta de nuevo.",
        );
      }
    } catch (err) {
      setStatus("error");
      setErrorMsg("Algo salió mal. Intenta de nuevo.");
    }
  };

  return (
    <section className="cn-section" id="contacto" data-testid="contact-section">
      <div className="cn-container cn-contact">
        <div className="cn-section-head">
          <p className="cn-eyebrow" data-reveal>
            EVALUACIÓN TÉCNICA GRATUITA
          </p>
          <h2 className="cn-h2" data-reveal data-testid="contact-headline">
            Solicita una evaluación técnica y descubre cómo Caruna puede
            habilitar tu infraestructura de voz.
          </h2>
        </div>

        <form
          className="cn-form"
          onSubmit={handleSubmit}
          data-reveal
          data-testid="contact-form"
          noValidate
        >
          <label className="cn-field">
            <span className="cn-field-label">Nombre completo</span>
            <input
              type="text"
              required
              value={form.nombre}
              onChange={handleChange("nombre")}
              data-testid="contact-input-nombre"
              autoComplete="name"
            />
          </label>
          <label className="cn-field">
            <span className="cn-field-label">Empresa</span>
            <input
              type="text"
              required
              value={form.empresa}
              onChange={handleChange("empresa")}
              data-testid="contact-input-empresa"
              autoComplete="organization"
            />
          </label>
          <label className="cn-field">
            <span className="cn-field-label">Correo corporativo</span>
            <input
              type="email"
              required
              value={form.correo}
              onChange={handleChange("correo")}
              data-testid="contact-input-correo"
              autoComplete="email"
            />
          </label>
          <label className="cn-field">
            <span className="cn-field-label">Teléfono</span>
            <input
              type="tel"
              value={form.telefono}
              onChange={handleChange("telefono")}
              data-testid="contact-input-telefono"
              autoComplete="tel"
            />
          </label>
          <label className="cn-field">
            <span className="cn-field-label">¿Qué necesitas integrar?</span>
            <textarea
              rows={4}
              value={form.mensaje}
              onChange={handleChange("mensaje")}
              data-testid="contact-input-mensaje"
            />
          </label>

          <button
            type="submit"
            className="cn-btn cn-btn-gradient cn-btn-block"
            disabled={status === "loading"}
            data-testid="contact-submit"
          >
            {status === "loading" ? (
              <>
                <Loader2 size={18} className="cn-spin" /> Enviando…
              </>
            ) : (
              "Agendar Sesión de Descubrimiento"
            )}
          </button>

          <p className="cn-form-caption" data-testid="contact-caption">
            Sin spam. Solo respuesta técnica especializada.
          </p>

          {status === "success" && (
            <p
              className="cn-form-msg cn-form-msg-success"
              data-testid="contact-success"
              role="status"
            >
              <CheckCircle2 size={18} />
              ¡Listo! En breve te contactamos.
            </p>
          )}
          {status === "error" && (
            <p
              className="cn-form-msg cn-form-msg-error"
              data-testid="contact-error"
              role="alert"
            >
              <AlertCircle size={18} />
              {errorMsg || "Algo salió mal. Intenta de nuevo."}
            </p>
          )}
        </form>
      </div>
    </section>
  );
};

export default ContactForm;
